import { useEffect, useState } from "react";
import axios from "axios";
import { Download, Loader2, ExternalLink } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LDC_LOGO = "https://customer-assets.emergentagent.com/job_artist-portal-ldc/artifacts/39dze3hq_Text%20Logo%20Gold_noBG_WEBP.webp";

export default function PosterSharePage({ recordId, attachmentId }) {
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/poster/${recordId}/${attachmentId}/meta`)
      .then((r) => setMeta(r.data))
      .catch(() => setError(true));
  }, [recordId, attachmentId]);

  const downloadUrl = `${API}/public/poster/${recordId}/${attachmentId}/download`;
  const dims = meta?.width && meta?.height ? `${meta.width} × ${meta.height}` : "";
  const label = !meta ? "" : meta.width === meta.height ? "SQUARE" : meta.width > meta.height ? "LANDSCAPE" : "STORY";

  return (
    <div className="share-page" data-testid="poster-share-page">
      <header className="share-page-head">
        <a href="https://londondrumsticks.co.uk" target="_blank" rel="noreferrer">
          <img src={LDC_LOGO} alt="London Drumstick Co." className="share-page-logo" />
        </a>
        <p className="share-page-tag">HAND-TURNED · WEIGHT-MATCHED · TOUR-READY</p>
      </header>

      <main className="share-page-main">
        {error && (
          <div className="share-page-card share-page-error" data-testid="poster-share-error">
            <h1 className="share-page-title">POSTER NOT FOUND</h1>
            <p>This poster may have been removed or the link is incomplete.</p>
            <a className="share-page-btn ghost" href="https://londondrumsticks.co.uk/artists" target="_blank" rel="noreferrer">
              VISIT LDC ARTISTS <ExternalLink size={16} />
            </a>
          </div>
        )}
        {!meta && !error && (
          <div className="share-page-card" data-testid="poster-share-loading">
            <Loader2 size={36} className="spin gold" />
          </div>
        )}
        {meta && (
          <div className="share-page-card" data-testid="poster-share-card">
            <p className="share-page-kicker">{label} POSTER {dims && `· ${dims}`}</p>
            <h1 className="share-page-title" data-testid="poster-share-artist">{meta.artist_name}</h1>
            {meta.band_name && <p className="share-page-band">{meta.band_name}</p>}
            <div className={`share-page-img ${label.toLowerCase()}`}>
              <img src={meta.url} alt={`${meta.artist_name} poster`} data-testid="poster-share-img" />
            </div>
            <div className="share-page-actions">
              <a className="share-page-btn" href={downloadUrl} data-testid="poster-share-download">
                <Download size={18} /> DOWNLOAD PNG
              </a>
              <a className="share-page-btn ghost" href={meta.url} target="_blank" rel="noreferrer" data-testid="poster-share-open">
                OPEN FULL SIZE <ExternalLink size={16} />
              </a>
            </div>
            <p className="share-page-hint">Post it and tag <strong>@londonstickco</strong> so we can repost you.</p>
          </div>
        )}
      </main>

      <footer className="share-page-foot">
        © London Drumstick Co. · <a href="https://londondrumsticks.co.uk" target="_blank" rel="noreferrer">londondrumsticks.co.uk</a>
      </footer>
    </div>
  );
}
